const clearPositions = (storage: Storage, matches: (key: string) => boolean) => {
  for (let index = storage.length - 1; index >= 0; index--) {
    const key = storage.key(index);
    if (key && matches(key)) storage.removeItem(key);
  }
};

/** Start full-page visits at the latest posts; retain positions during in-app navigation. */
const initializeTimelineSession = (reload: () => void) => {
  try {
    clearPositions(window.localStorage, (key) => /^nicolium:.+:homeTimelinePosition$/u.test(key));
  } catch {
    // Storage can be unavailable in restricted browser contexts.
  }
  try {
    clearPositions(window.sessionStorage, (key) => key.startsWith('nicolium:scrollData:'));
  } catch {
    // Storage can be unavailable in restricted browser contexts.
  }

  // A page-cache restore resumes the old application without running startup again.
  const handlePageShow = (event: PageTransitionEvent) => {
    if (event.persisted) reload();
  };
  window.addEventListener('pageshow', handlePageShow);
  return () => window.removeEventListener('pageshow', handlePageShow);
};

export { initializeTimelineSession };
